import {useContext} from 'react';
import {Stack, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';
import './styles.scss';
import {translations} from '../../../../../../../i18n/translations';
import {AppContext} from '../../../../../../../contexts/app/context';
import {AppContextType} from '../../../../../../../contexts/app/types';
import {ThemeMode} from '../../../../../../../enums/theme-mode';
import {Pallete} from '../../../../../../../theme/bluebird';

const Confirm = ({name}: {name: string}) => {
  const appContext: AppContextType = useContext(AppContext);

  const {t} = useTranslation();

  return (
    <Stack className="content-wrapper">
      <Typography
        component="h3"
        className="title"
        sx={{
          color:
            appContext.state.currentThemeMode === ThemeMode.Light
              ? Pallete.gray.base
              : Pallete.white.base,
        }}
      >
        {t(translations.seniors.root.modals.add_senior_flow.confirm.confirm_title, {
          name,
        })}
      </Typography>
      <Typography
        component="h5"
        className="subtitle"
        sx={{
          color:
            appContext.state.currentThemeMode === ThemeMode.Light ? '#b6b6b6' : Pallete.gray.light,
        }}
      >
        {t(translations.seniors.root.modals.add_senior_flow.confirm.confirm_subtitle)}
      </Typography>
    </Stack>
  );
};

export default Confirm;
